import React from 'react';
import PropTypes from 'prop-types';

import { FormattedDate, FormattedMessage } from 'react-intl';

import SocialMediaSharing from '../../../atoms/SocialMediaSharing';
import AnchorLink from '../../../atoms/AnchorLink';
import TagsWrapper from '../../Tags/TagsWrapper';
import { Schedule } from '@mui/icons-material';
import * as style from './index.module.css';

class SinglePublicationMetaContent extends React.Component
{
    injectDescriptionLinebreaks(description)
    {
        if (!description)
        {
            return null;
        }
        const splitDescription = description.split('\n');

        return splitDescription.map(
            (chunk, index) =>
                <p
                    style={index !== splitDescription.length - 1 ? { marginBottom: '1rem' } : {}} key={index}>{chunk}
                </p>,
        );
    }

    render()
    {
        const {
            titleDe,
            titleEn,
            descriptionDe,
            descriptionEn,
            publishingOrganizationName,
            linkToPublisherOrganizationSite,
            originalAuthor,
            publishToGlaubensfutterDate,
            clipLongText,
            tags,
            locale,
            estimatedReadingTime,
        } = this.props;
        let publisherContent = null;
        if (linkToPublisherOrganizationSite && publishingOrganizationName)
        {
            publisherContent = (
                <React.Fragment>
                    <AnchorLink
                        style={{
                            color: 'gray',
                            marginBottom: '1rem',
                        }}
                        title={publishingOrganizationName}
                        href={linkToPublisherOrganizationSite}
                        target="_blank"
                    >
                        <span
                        >{clipLongText(publishingOrganizationName, 35)}</span>
                    </AnchorLink>
                    <span style={{ color: 'charcoal' }}>{originalAuthor}</span>
                    <span style={{ color: 'gray', marginBottom: '.3rem' }}>
                        <FormattedDate
                            value={publishToGlaubensfutterDate}
                            year="numeric"
                            month="numeric"
                            day="numeric"
                            weekday="long"
                        />
                    </span>
                </React.Fragment>
            );
        }

        return (
            <div className={style.singlePublicationMetaContent}>
                <div className={style.singlePublicationPublisherContent}>
                    {publisherContent}
                    {
                        estimatedReadingTime && (
                            <div style={{ display: 'flex', padding: '3px', fontSize: '1rem', lineHeight: '.7rem' }}>
                                <Schedule style={{ color: '#545454', fontSize: '20px', marginRight: '3px' }} />
                                <span style={{ marginLeft: '3px' }}>{estimatedReadingTime} Min.</span>
                            </div>
                        )
                    }
                </div>

                <SocialMediaSharing
                    title={titleDe || titleEn}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'left',
                        marginTop: '1rem',
                        marginBottom: '0',
                        marginLeft: -7,
                    }}
                    childStyle={{
                        padding: '4px',
                        cursor: 'pointer',
                    }}
                    description={descriptionDe || descriptionEn}
                />
                <TagsWrapper
                    style={{ marginTop: '1rem' }}
                    label="Tags:"
                    locale={locale}
                    tags={tags}
                />
                <div className={style.singlePublicationDescriptionContent}>
                    <div className={style.singlePublicationDescriptionHeader}>
                        <FormattedMessage id="description"/>
                    </div>
                    <div>
                        {this.injectDescriptionLinebreaks(descriptionDe || descriptionEn)}
                    </div>
                </div>
            </div>
        );
    }
}

SinglePublicationMetaContent.propTypes = {
    titleDe: PropTypes.string,
    titleEn: PropTypes.string,
    descriptionDe: PropTypes.string,
    descriptionEn: PropTypes.string,
    publishingOrganizationName: PropTypes.string,
    linkToPublisherOrganizationSite: PropTypes.string,
    originalAuthor: PropTypes.string,
    publishToGlaubensfutterDate: PropTypes.number,
    clipLongText: PropTypes.func,
    tags: PropTypes.array,
    locale: PropTypes.string,
    estimatedReadingTime: PropTypes.number,
};

export default SinglePublicationMetaContent;
